import { Component, input, output, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface FilterCard {
    id: string;
    label: string;
    count: number;
    color?: string; // hex color or CSS color name
}

@Component({
    selector: 'app-filter-cards',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './filter-cards.component.html',
    styleUrls: ['./filter-cards.component.scss']
})
export class FilterCardsComponent {
    // Inputs
    label = input.required<string>(); // "Estados:", "Telemetría:", etc.
    cards = input.required<Array<FilterCard>>();
    selectedIds = input<Set<string>>(new Set());
    showAllCard = input<boolean>(true);
    allCardLabel = input<string>('Todos');
    totalCount = input<number>(0);

    // Outputs
    cardToggled = output<string>();
    allCleared = output<void>();

    // Check if a card is selected
    isSelected(cardId: string): boolean {
        return this.selectedIds().has(cardId);
    }

    // Check if "All" is selected (no filters active)
    isAllSelected(): boolean {
        return this.selectedIds().size === 0;
    }

    // Handle card click
    onCardClick(cardId: string): void {
        this.cardToggled.emit(cardId);
    }

    // Handle "All" click
    onAllClick(): void {
        this.allCleared.emit();
    }
}
